var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Settings")]),_vm._v(" "),_c('el-alert',{attrs:{"title":"Chưa có nội dung","type":"info","closable":false,"show-icon":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d04e3ae","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/index.vue
// module id = 741
// module chunks = 0